import { useEffect, useState } from 'react';

export const useDashboardToken = (): { guestToken: string | null; urlToken: string | null } => {
    const [storedToken, setStoredToken] = useState<string | null>(() => localStorage.getItem('dashboard_token'));

    const { searchParams } = new URL(window.location.href);
    const urlToken = searchParams.get('t');

    useEffect(() => {
        if (urlToken && urlToken !== storedToken) {
            localStorage.setItem('dashboard_token', urlToken);
            setStoredToken(urlToken);
        }
    }, [urlToken, storedToken]);

    return {
        guestToken: urlToken || storedToken,
        urlToken,
    };
};
